export const SUCCESS_REGISTER_MODAL_MESSAGE = '가입이 완료됐어요.';
export const SUCCESS_PROFILE_EDIT_MODAL_MESSAGE = '프로필이 수정됐어요.';
export const LOGOUT_MODAL_MESSAGE = '로그아웃 하시겠어요?';
export const SUCCESS_RIVIEW_MODAL_MESSAGE = '리뷰가 작성됐어요.';
export const SUCCESS_GATHERING_CREATE_MODAL_MESSAGE = '모임이 생성됐어요';
export const SUCCESS_GATHERING_JOIN_MODAL_MESSAGE = '모임에 참가했어요.';
export const OUT_GATHERING_MODAL_MESSAGE = '정말 모임을 나가시겠어요?';
export const SUCCESS_OUT_GATHERING_MODAL_MESSAGE = '모임에서 나갔어요.';
export const DELETE_GATHERING_MODAL_MESSAGE = '정말 모임을 삭제하시겠어요?';
export const SUCCESS_DELETE_GATHERING_MODAL_MESSAGE = '모임이 취소됐어요.';
export const SUCCESS_FIX_GATHERING_MODAL_MESSAGE = '모임이 확정됐어요.';
export const SUCCESS_UNFIX_GATHERING_MODAL_MESSAGE = '모임 확정이 취소됐어요.';

export const KICK_PARTICIPANT_MODAL_MESSAGE = '정말 강퇴하시겠어요?';

export const SUCCESS_KICK_PARTICIPANT_MODAL_MESSAGE = '강퇴했어요.';

export const SUCCESS_CREATE_TIP = '공략이 작성됐어요.';
export const SUCCESS_DELETE_TIP = '공략을 삭제했어요.';

export const DELETE_TIP_MODAL_MESSAGE = '정말 공략을 삭제하시겠어요?';
